import { render, staticRenderFns } from "./referrer-list-loader.vue?vue&type=template&id=5cee98ea"
import script from "./referrer-list-loader.vue?vue&type=script&lang=js"
export * from "./referrer-list-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports